import { Flex } from "@/atoms"
import { LeftKeyboardHint, RightKeyboardHint } from "@/icons"

import styles from "./FooterItem.module.scss"

export const EditFilterHint = () => {
  return (
    <Flex gap={4} align="center">
      <LeftKeyboardHint className={styles.keyboardHint} />
      <RightKeyboardHint className={styles.keyboardHint} />
    </Flex>
  )
}
